<template>
    <div class="edit-table-box">
        <el-table
            ref="moduleTable"
            border
            tooltip-effect='dark'
            v-loading="loading"
            :height="height"
            :data="tableData"
            :row-class-name="tableRowClassName"
            v-bind="$attrs"
            @selection-change="handleSelectionChange"
            @row-click='rowClick'
            @row-dblclick="rowDBclick">
            <el-table-column
                v-if="selection"
                type="selection"
                width="40"
                fixed="left"></el-table-column>
            <el-table-column
                v-for="(item, index) in columnsList"
                :show-overflow-tooltip="true"
                :key="index"
                :min-width="_.get(item, 'width', '')">
                <template v-slot:header="scope">
                    <div v-if="!item.customHeader">
                        <span class="must-fill-flag" v-if="item.mustFill">*</span>{{item.label}}
                    </div>
                    <!-- 通过 customHeader 属性判断是否自定义表头 -->
                    <slot v-else name="custom-header" v-bind="{ item, scope }"></slot>
                </template>
                <template slot-scope="scope">
                    <!-- start：编辑状态 -->
                    <div style="display: flex;" v-if="scope.row.edit !== EDIT_TYPE.CANCEL">
                        <template v-if="!item.type">{{scope.row[item.prop]}}</template>
                        <el-select
                            v-else-if="item.type === 'select'"
                            v-model="scope.row[item.prop]"
                            size='mini'
                            :class="{'error-active': _.get(errorList, `[${scope.$index}][${index}]`)}"
                            :clearable="_.get(item, 'clearable',true)"
                            :filterable="item.filterable"
                            :disabled="_columnIfDisabled(scope.row, item)"
                            :multiple="_.get(item, 'multiple', false)"
                            :placeholder="item.placeholder"
                            @change="(val) => elementChange(item.prop, val, scope.row, scope.$index)">
                            <el-option
                                v-for="(val, key) in _.get(scope.row, `${item.prop}Options`, item.options)"
                                :key="key"
                                :label="val"
                                :value="key"
                            ></el-option>
                        </el-select>
                        <addressSelect
                            v-else-if="item.type === 'addressSelect'"
                            v-model="scope.row[item.prop]"
                            :class="{'error-active': _.get(errorList, `[${scope.$index}][${index}]`)}"
                            :minLayers="_.get(scope.row, `${item.prop}Layers`,item.minLayers)"
                            :disabled="_columnIfDisabled(scope.row, item)"
                            :basicProps="item.config"
                            @getAddress="labels => getAddress(scope.row, item, labels)"
                            @input="val => elementChange(item.prop, val, scope.row, scope.$index)"
                        ></addressSelect>
                        <el-switch
                            class="edit-table-box_switch"
                            v-else-if="item.type === 'switch'"
                            v-model="scope.row[item.prop]"
                            :disabled="_columnIfDisabled(scope.row, item)"
                            :active-value="_.get(item, 'activeValue', 'Y')"
                            :inactive-value="_.get(item, 'inactiveValue', 'N')"
                            :active-text="item.activeText"
                            :inactive-text="item.inactiveText"
                            @change="(val) => elementChange(item.prop, val, scope.row, scope.$index)"
                        ></el-switch>
                        <lots-basic-data-selector
                            v-else-if="item.type === 'lotsBasicData'"
                            :disabled="_columnIfDisabled(scope.row, item)"
                            :config="item.config"
                            v-model="scope.row[item.prop]"
                            @change="(val) => elementChange(item.prop, val, scope.row, scope.$index)"
                        ></lots-basic-data-selector>
                        <lots-md-input
                            v-else-if="item.type === 'advance'"
                            :label="scope.row[item.prop]"
                            :class="{'error-active': _.get(errorList, `[${scope.$index}][${index}]`)}"
                            :disabled="_columnIfDisabled(scope.row, item)"
                            :config="item"
                            :cascadeData="scope.row"
                            @change="data => handleMdInputChange(data, scope.row)"
                        ></lots-md-input>
                        <slot
                            v-else-if="item.type === 'custom'"
                            name="table-append"
                            v-bind="{ item, itemSetting: scope, index: scope.$index }"
                            >
                        </slot>
                        <!-- <el-input
                            readonly
                            v-else-if="item.type === 'advance'"
                            v-model="scope.row[item.prop]"
                            size='mini'
                            :class="{'error-active': _.get(errorList, `[${scope.$index}][${index}]`)}"
                            :disabled="_columnIfDisabled(scope.row, item)"
                            @keyup.113.native="detailSearch(scope.$index, item.prop, item, 2, scope.row[item.prop])"
                            @keyup.enter.native="detailSearch(scope.$index, item.prop, item, 2, scope.row[item.prop])"
                            >
                            <el-button
                                slot="append"
                                icon="el-icon-search"
                                :disabled="_columnIfDisabled(scope.row, item)"
                                @click="detailSearch(scope.$index, item.prop, item, 2, scope.row[item.prop])"
                            ></el-button>
                            <i
                                slot="suffix"
                                class="el-input__icon el-icon-circle-close"
                                v-if="scope.row[item.prop]"
                                @click="resetAdvanceParams(item.prop, scope.row)"
                            ></i>
                        </el-input> -->
                        <el-input
                            :clearable="_.get(item, 'clearable',true)"
                            v-else-if="item.type === 'input'"
                            v-model="scope.row[item.prop]"
                            size='mini'
                            :disabled="_columnIfDisabled(scope.row, item)"
                            :class="{'error-active': _.get(errorList, `[${scope.$index}][${index}]`)}"
                            @input="(val) => elementChange(item.prop, val, scope.row, scope.$index)"
                        ></el-input>
                        <slot v-else-if="item.editSlot" name="edit-col-append" v-bind="{ item, row: scope.row, rIndex: scope.$index }"></slot>
                    </div>
                    <!-- start：非编辑状态 -->
                    <template v-else>
                        <el-switch
                            v-if="item.type === 'switch'"
                            class="edit-table-box_switch" v-model="scope.row[item.prop]"
                            disabled
                            :active-value="_.get(item, 'activeValue', 'Y')"
                            :inactive-value="_.get(item, 'inactiveValue', 'N')"
                            :active-text="item.activeText"
                            :inactive-text="item.inactiveText"
                        ></el-switch>
                        <slot v-else-if="item.slot" name="col-append" v-bind="{ item, row: scope.row, rIndex: scope.$index }"></slot>
                        <template v-else>
                            {{dataFormat(scope.row, item)}}
                        </template>
                    </template>
                </template>
            </el-table-column>
            <el-table-column
                :label="$translate('component.E202006152352', { defaultText: '操作' })"
                fixed="right"
                :width="actionColWidth"
                v-if="control===true">
                <template slot-scope="scope">
                    <el-button size="mini" type="text" v-if="scope.row.edit === EDIT_TYPE.CANCEL"
                               :disabled="editDisableRule(scope.row)"
                               @click.stop="btnEvent(scope.row,'edit')">{{$translate('lang.E2202105110023', { defaultText: '编辑' })}}
                    </el-button>
                    <el-button size="mini" type="text" v-else @click.stop="btnEvent(scope.row, 'cancel')">{{$translate('lang.E2202105110094', { defaultText: '取消' })}}</el-button>
                    <template v-for="(e, eIndex) in actions.list">
                        <el-button v-if="e.displayRule(scope.row, EDIT_TYPE)" type="text" size="mini" :key="eIndex"
                                   @click.stop="actionClick(e.event, scope.row, scope.$index)">{{e.label}}
                        </el-button>
                    </template>
                </template>
            </el-table-column>
        </el-table>
        <advance-dialog ref="advanceDialog"></advance-dialog>
    </div>
</template>
<script>
import _ from 'lodash';
import { dictWithUrl } from '../api';
import addressSelect from '@/components/lots/otpCascader2';
import advanceDialog from '@/components/lots/otpAdvanceDialog';
import lotsMdInput from '@/components/lots/lotsMdInput';
import lotsBasicDataSelector from '@/components/lots/lotsBasicDataSelector';
import { I18nMixins } from '@/components/utils/i18n';

export default {
    name: 'EditTableBox',
    mixins: [I18nMixins],
    data() {
        return {
            EDIT_TYPE: { EDIT: 2, CANCEL: -3 },
            selectedRowsData: [],
            errorList: [],
            columnsList: [],
            keyMap: {},
            dataFormat: (row, col) => {
                if (!col.options) {
                    return row[col.prop];
                }
                // 处理方式：options使用简单对象
                return _.get(col.options, row[col.prop], row[col.prop]);
            }
        };
    },
    props: {
        selection: {
            type: Boolean,
            default() {
                return true;
            }
        },
        height: {
            type: [Number, String],
            default() {
                const heightOffset = 152;
                const $el = document.querySelector('.app-main');
                if (!$el) return 0;
                const tableHeight = $el.getBoundingClientRect().height - heightOffset;
                return tableHeight;
            }
        },
        columns: {
            type: Array,
            required: true,
            default() {
                return [];
            }
        },
        tableData: {
            type: Array,
            default() {
                return [];
            }
        },
        loading: {
            type: Boolean,
            default() {
                return false;
            }
        },
        customColumnProps: {
            type: String,
            default() {
                return '';
            }
        },
        control: {
            type: Boolean,
            default() {
                return true;
            }
        },
        actions: {
            type: Object,
            default() {
                return {
                    list: []
                };
            },
            validator: function (obj) {
                return !!obj.list;
            }
        },
        allowRowClick: {
            type: Boolean,
            default() {
                return true;
            }
        },
        banMultiRowEditForRowClick: {
            type: Boolean,
            default() {
                return true;
            }
        },
        editDisableRule: {
            type: Function,
            default() {
                return false;
            }
        }
    },
    components: { addressSelect, advanceDialog, lotsMdInput, lotsBasicDataSelector },
    methods: {
        actionClick(event, row, rIndex) {
            this.$emit('action-click', event, row, rIndex);
        },
        tableRowClassName({ row }) {
            if (this.selectedRowsData && this.selectedRowsData.includes(row)) {
                return 'highlight-row';
            }
        },
        _columnIfDisabled(row, col) {
            return _.isArray(row.disableProps) ? row.disableProps.includes(col.prop) : col.disabled;
        },
        addRow() {
            // 新增一行，并进入行内编辑模式
            const obj = {};
            this.columnsList.forEach(item => {
                obj[item.prop] = item.defaultValue || '';
            });
            obj.edit = this.EDIT_TYPE.EDIT;
            this.tableData.unshift(obj);
            // 新增默认勾选
            this.$refs.moduleTable.toggleRowSelection(obj, true);
        },
        elementChange(prop, val, row, index) {
            this.$emit('element-change', {
                prop,
                val,
                row,
                index
            });
        },
        handleSelectionChange(selection) {
            this.selectedRowsData = this.getTable().selection;
            this.$emit('selection-change', selection);
        },
        rowDBclick(row) {
            this.$emit('row-db-click', row);
        },
        btnEvent(selection, event) {
            if (event === 'edit' || event === 'cancel') {
                // 状态取反
                selection.edit = ~selection.edit;
                if (selection.edit === this.EDIT_TYPE.CANCEL) {
                    if (!selection.id) {
                        this.tableData.splice(selection.serialNum, 1);
                    } else if (selection.backup) {
                        this.$set(this.tableData, selection.serialNum, selection.backup);
                        this.$set(this.tableData[selection.serialNum], 'edit', this.EDIT_TYPE.CANCEL);
                    }
                } else {
                    selection.backup = _.cloneDeep(selection);
                    this.$refs.moduleTable.toggleRowSelection(selection, true);
                }
            }
            this.$emit('btn-event', selection, event);
        },
        rowClick(rows) {
            if (this.allowRowClick && !this.editDisableRule(rows)) {
                if (rows.edit === this.EDIT_TYPE.EDIT) {
                    return;
                }
                if (this.banMultiRowEditForRowClick) {
                    this.tableData.forEach(item => {
                        item.edit = this.EDIT_TYPE.CANCEL;
                    });
                }
                this.tableData[rows.serialNum].edit = this.EDIT_TYPE.EDIT;
                rows.backup = _.cloneDeep(rows);
                if (rows) {
                    this.initRowBg(rows.serialNum);
                    this.$refs.moduleTable.toggleRowSelection(rows, true);
                }
            }
        },
        // 提供给外部使用，验证表单字段（单条数据）
        saveItemData(data) {
            let ModifyData = _.cloneDeep([data]).map(item => {
                delete item.backup;
                delete item.edit;
                return item;
            });
            if (!this.tableExamine(ModifyData)) {
                ModifyData = false;
            }
            return ModifyData;
        },
        // 提供给外部使用，验证表单字段（勾选中的数据）
        saveData() {
            let ModifyData = _.cloneDeep(this.selectedRowsData).map(item => {
                delete item.backup;
                delete item.edit;
                return item;
            });
            if (!this.tableExamine(ModifyData)) {
                ModifyData = false;
            }
            return ModifyData;
        },
        // 表格提交验证
        tableExamine(data) {
            let errorHint = false;
            let errorMsg = '';
            // 重置错误提醒对象
            this.errorList = this.tableData.map(item => {
                return Array(Object.keys(item).length).fill(false);
            });
            data.forEach(data => {
                this.columnsList.forEach((column, index) => {
                    const propIsNecessary = data.notNecessaryProps ? !data.notNecessaryProps.includes(column.prop) : column.mustFill;
                    const notNull = data[column.prop] !== undefined && data[column.prop] !== null && data[column.prop] !== '';
                    if (propIsNecessary) {
                        if (notNull) {
                            if (_.isArray(data[column.prop]) && data[column.prop].length === 0) {
                                this.errorList[data.serialNum][index] = errorHint = true;
                                errorMsg = errorMsg === '' ? this.$translate('component.E202011260008', { defaultText: '必填项不能为空' }) : errorMsg;
                            }
                        } else {
                            this.errorList[data.serialNum][index] = errorHint = true;
                            errorMsg = errorMsg === '' ? this.$translate('component.E202011260008', { defaultText: '必填项不能为空' }) : errorMsg;
                        }
                    }
                    if (notNull && column.verify && !RegExp(column.verify).test(data[column.prop])) {
                        this.errorList[data.serialNum][index] = errorHint = true;
                        errorMsg = errorMsg === ''
                            ? (column.errorMsg ? column.errorMsg : this.$translate('component.E202011260009', { defaultText: '部分选项格式不正确' }))
                            : errorMsg;
                    }
                });
            });
            if (errorHint) {
                this.$message.error(errorMsg);
            }
            return !errorHint;
        },
        detailSearch(row, data, item, type, searchData) {
            if (!searchData) {
                searchData = '';
            }
            //  当前操作的行
            const currentOperateRow = this.tableData[row];
            const advanceCascade = {};
            // 高级搜索级联操作，current.advanceCascade为需要级联的参数的key的集合，例如advanceCascade: key1,key2,key3
            if (item && _.isString(item.advanceCascade)) {
                let advanceArray = [];
                advanceArray = item.advanceCascade.split(',');
                advanceArray.map((item) => {
                    let { 0: sourceProp, 1: destProp } = item.split('#');
                    destProp = destProp || sourceProp;
                    advanceCascade[destProp] = this.tableData[row][sourceProp];
                });
            }
            this.$refs.advanceDialog.show(true, item, advanceCascade);
            this.$refs.advanceDialog.$once('confirm', (result) => {
                // 将返回数据添加到map里，用于高级搜索清空时，顺带清空其他关联属性
                const keyArr = Object.keys(result);
                if (keyArr.length > 0) {
                    keyArr.forEach(key => {
                        this.keyMap[key] = keyArr;
                    });
                }
                Object.assign(currentOperateRow, result);
                this.$emit('element-change', { val: _.cloneDeep(result), type: 'advance', row: currentOperateRow });
            });
        },
        dataInit(tableData) {
            const list = tableData || this.tableData;
            list.map((item, index) => {
                item.serialNum = index;
                if (item.id && !item.edit) {
                    this.$set(this.tableData[index], 'edit', this.EDIT_TYPE.CANCEL);
                }
                const errList = [];
                for (let i = 0; i < Object.keys(item).length; i++) {
                    errList.push(false);
                }
                this.$set(this.errorList, index, errList);
            });
            // 初始化keyMap
            this.columnsList.forEach(data => {
                if (data.type === 'advance' && _.isArray(data.cbParams)) {
                    const keys = data.cbParams.map(item => {
                        const arr = item.split('#');
                        return arr[1] || arr[0];
                    });
                    keys.forEach(key => {
                        this.keyMap[key] = keys;
                    });
                }
            });
            this.initRowBg();
        },
        // 初始化行背景，并高亮指定行
        initRowBg(rowIndex = null) {
            const arr = document.getElementsByClassName('el-table__row');
            for (let i = 0; i < arr.length; i++) {
                arr[i].style.background = '';
            }
            if (rowIndex) {
                arr[rowIndex].style.background = '#F1F8FA';
            }
            return arr;
        },
        // 转化中文地址数组成连续字符串
        getAddress(row, item, labels) {
            row[item.labelCn] = labels.join(' / ');
        },
        // 高级输入框的关闭按钮点击
        resetAdvanceParams(prop, row) {
            const keyArr = this.keyMap[prop];
            // 把属性相关联的字段置空
            _.isArray(keyArr) && keyArr.forEach(key => {
                row[key] = '';
            });
        },
        getTable() {
            return this.$refs['moduleTable'];
        },
        handleMdInputChange(data, row) {
            Object.assign(row, data);
            this.$emit('element-change', { val: _.cloneDeep(data), type: 'advance', row });
        },
        handleLotsBasicDataToText(row, col) {
            if (Array.isArray(row[col.prop])) {
                const labelKeyArr = col.config.labelKey.split('#');
                // 获取输出值label别名键位
                const labelDesKey = labelKeyArr[1] ? labelKeyArr[1] : labelKeyArr[0];
                const lotsBasicData = row[col.prop].reduce((preRs, item) => {
                    preRs.push(item[labelDesKey]);
                    return preRs;
                }, []);
                return lotsBasicData.join(' , ') || '';
            } else {
                return '';
            }
        }
    },
    watch: {
        actions: {
            handler(val) {
                if (val.list) {
                    _.forEach(val.list, ele => {
                        if (!_.isFunction(ele.displayRule)) {
                            ele.displayRule = () => true;
                        }
                    });
                }
            },
            immediate: true
        },
        tableData: function (val) {
            this.dataInit(val);
        },
        columns: {
            handler: function (arr) {
                this.columnsList = arr;
            },
            immediate: true
        },
        customColumnProps: function (list) {
            const datas = list.split(',');
            const columnsList = [];
            datas.forEach(prop => {
                this.columns.forEach(data => {
                    if (data.prop === prop) {
                        columnsList.push(data);
                    }
                });
            });
            this.columnsList = columnsList;
        }
    },
    computed: {
        _() {
            return _;
        },
        actionColWidth() {
            const btnWidth = 50;
            return this.actions.fixedWidth || btnWidth * this.actions.list.length;
        }
    },
    created() {
        // 表格渲染前先判断表格列中使用到的数据字典是否都在浏览器端有备份，没有的进行接口获取，保证表格的字典转义
        // const keys = _.chain(this.columns).map(obj => obj.optionsKey).filter(str => !_.isNil(str)).value();
        const selectCols = _.chain(this.columns).filter(obj => obj.optionsKey).value();
        selectCols.forEach(item => {
            if (item.optionsKey) {
                dictWithUrl(item.optionsKey, item.dictUrl).then(res => {
                    item.options = _.get(res.data, item.optionsKey) || {};
                });
            }
        });
        // 给转义函数重新赋值，触发重新渲染
        this.dataFormat = (row, col) => {
            // 为空，为0，为空数组时返回''
            if ((!row[col.prop] && row[col.prop] !== 0) || (_.isArray(row[col.prop]) && row[col.prop].length === 0)) {
                return '';
            }
            // 下拉框变为正常时显示值的改变
            let result = null;
            if (col.type === 'select') {
                const keyMaps = col.options;
                if (_.isArray(row[col.prop])) {
                    result = row[col.prop].map(val => {
                        val = val + '';
                        return _.get(keyMaps, val, val);
                    }).join(',');
                } else {
                    const value = row[col.prop] + '';
                    result = _.get(keyMaps, value, value);
                }
            } else if (col.type === 'addressSelect') {
                result = row[col.labelCn];
            } else if (col.type === 'lotsBasicData') {
                return this.handleLotsBasicDataToText(row, col);
            } else {
                result = row[col.prop];
            }
            return result;
        };
    }
};
</script>
<style lang="less">
    .edit-table-box {
        .el-table__body tr.highlight-row {
            background: #E1E7EF;
        }

        .error-active input {
            border-color: red;
        }

        .error-active .otpAllAddressSelect .el-cascader .el-input {
            border-color: red;
        }

        .edit-table-box_switch .el-switch__label {
            //position: absolute;
            //display: none;
            //color: #fff;
        }

        /*打开时文字位置设置*/

        .edit-table-box_switch .el-switch__label--right {
            z-index: 1;
            right: -10px;
        }

        /*关闭时文字位置设置*/

        .edit-table-box_switch .el-switch__label--left {
            z-index: 1;
            left: 26px;
        }

        /*显示文字*/

        .edit-table-box_switch .el-switch__label.is-active {
            display: block;
        }

        .must-fill-flag {
            // font-size: 14px;
            color: #f25555;
            margin-right: 2px;
        }
    }
</style>
